import { NativePlatform } from '@fullstory/proto/fs/api/segment';
import { ObjectInfo, ObjectPlatform } from '@fullstory/renderer-shared';
import { assertExhaustive } from '@fullstory/typeutils';

const interactiveTags = new Set<string>(['a', 'button', 'input']);

/**
 * @returns true if the given object looks interactive, based on the
 * information we have.
 */
export const isInteractive = (object: ObjectInfo): boolean =>
  interactiveTags.has(object.selector.rule?.tag ?? '');

export const toNativePlatform = (
  platform: ObjectPlatform | undefined,
): NativePlatform | undefined => {
  if (!platform) return undefined;
  switch (platform) {
    case 'web':
      return NativePlatform.NATIVE_PLATFORM_WEB;
    case 'android':
      return NativePlatform.NATIVE_PLATFORM_ANDROID;
    case 'ios':
      return NativePlatform.NATIVE_PLATFORM_IOS;
    default:
      assertExhaustive(platform);
  }
};

/**
 * A helper that sorts objects based on the priority with which they should be
 * selected.
 */
export const selectionOrder = (a: ObjectInfo, b: ObjectInfo): number => {
  const aIsInteractive = isInteractive(a) ? 1 : 0;
  const bIsInteractive = isInteractive(b) ? 1 : 0;
  // Interactive elements should be selected first.
  return bIsInteractive - aIsInteractive;
};

export const fillParentStyles: React.CSSProperties = {
  borderWidth: 0,
  boxSizing: 'border-box',
  width: '100%',
  height: '100%',
};
